import { defineMessages } from 'react-intl'

export default defineMessages({
  requestUrl: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.requestUrl',
    defaultMessage: 'Request URL'
  },
  requestMethod: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.requestMethod',
    defaultMessage: 'POST'
  },
  requestUrlDescription: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.requestUrlDescription',
    defaultMessage:
      'You can make requests to any HTTP API to connect workflows to your application’s internal API, or with any REST APIs in general.'
  },
  credentials: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.credentials',
    defaultMessage: 'Credentials'
  },
  credentialsDescription: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.credentialsDescription',
    defaultMessage:
      'Generate HTTP Trigger API credentials for your application and save these values in a secure location. They will be used by your server to generate an OAuth2 access token.'
  },
  clientID: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.clientId',
    defaultMessage: 'Client ID'
  },
  clientSecret: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.clientSecret',
    defaultMessage: 'Client Secret'
  },
  generateCredentials: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.generateCredentials',
    defaultMessage: 'Generate Credentials'
  },
  resetCredentials: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.resetCredentials',
    defaultMessage: 'Regenerate secret'
  },
  onlyDisplayedOnce: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.secretDisplayedOnce',
    defaultMessage: '(This will only be displayed once!)'
  },
  definePayload: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.definePayload',
    defaultMessage: 'Define Payload'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  payloadInvalidJson: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.payloadInvalidJson',
    defaultMessage: 'Please enter valid JSON'
  },
  pleaseDefinePayload: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.pleaseDefinePayload',
    defaultMessage: 'Please define a request payload'
  },
  alreadyGenerated: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.AlreadyGenerated',
    defaultMessage: 'Client secret has already been generated'
  },
  pleaseGenerateClientCredentials: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.pleaseGenerateClientCredentials',
    defaultMessage: 'Please generate client credentials'
  },
  beautify: {
    id: 'SpaceAppBuilderFeaturesPage.httpRequestTrigger.beautify',
    defaultMessage: 'Beautify Code'
  }
})
